import {
  SUMMARY_VIEW_VERSION,
  type SummaryViewPayload
} from "./summaryViewPayload";

/** The views the picker offers before the user saves any of their own. */
export const BUILT_IN_SUMMARY_VIEW_KEYS = ["Compact"] as const;

export type BuiltInSummaryViewKey = (typeof BUILT_IN_SUMMARY_VIEW_KEYS)[number];

/**
 * One built-in: the Compact KPI columns. It is also the way to any other
 * set — open the columns the view hides from the column menu and save.
 */
export const BUILT_IN_SUMMARY_VIEWS: Record<
  BuiltInSummaryViewKey,
  SummaryViewPayload
> = {
  Compact: {
    version: SUMMARY_VIEW_VERSION,
    columns: { category: "Compact" }
  }
};

/** The view a summary page opens on with no default of the user's own. */
export const DEFAULT_BUILT_IN_SUMMARY_VIEW: BuiltInSummaryViewKey = "Compact";
